/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Adjustment_Gl_AccountInputs */

const en_reference_field_adjustment_gl_account = /** @type {(inputs: Reference_Field_Adjustment_Gl_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account of the stock adjustments`)
};

/**
* | output |
* | --- |
* | "Account of the stock adjustments" |
*
* @param {Reference_Field_Adjustment_Gl_AccountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_adjustment_gl_account = /** @type {((inputs?: Reference_Field_Adjustment_Gl_AccountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Adjustment_Gl_AccountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_adjustment_gl_account(inputs)
});